import React, { FC } from "react";
import { Col, Divider, Empty, Row, Typography } from "antd";
import { Loader, Page } from "shared/ui";
import {
  useGetMachineOverviewQuery,
  useGetUserOverviewQuery,
} from "shared/api";
import { MachineCard, OverviewThisWeekTasks, UserCard } from "./ui";

const { Title } = Typography;

const Overview: FC = () => {
  const { data: machines, isLoading: machinesLoading } =
    useGetMachineOverviewQuery();
  const { data: users, isLoading: usersLoading } = useGetUserOverviewQuery();

  const isLoading = machinesLoading || usersLoading;

  return (
    <Page title="Overview">
      {isLoading ? (
        <div className="flex min-h-[calc(100dvh-11rem)] w-full items-center justify-center px-4">
          <Loader />
        </div>
      ) : (
        <div className="flex flex-col overflow-hidden">
          <div className="flex min-h-0 flex-1 flex-col">
            <Title
              level={5}
              className="!mb-3 !mt-0 shrink-0 text-neutral-500 !text-2xl"
            >
              Machines
            </Title>
            <div className="min-h-0 flex-1 overflow-y-auto px-2 pb-2 [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-button]:hidden [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-neutral-300 hover:[&::-webkit-scrollbar-thumb]:bg-neutral-400">
              {machines?.length ? (
                <Row gutter={[16, 16]}>
                  {machines.map((item, index) => (
                    <Col key={index} xs={24} sm={12} md={8} lg={4}>
                      <MachineCard item={item} />
                    </Col>
                  ))}
                </Row>
              ) : (
                <Empty description="No machine data available" />
              )}
            </div>
          </div>

          <Divider className="shrink-0" />

          <div className="flex min-h-0 flex-1 flex-col">
            <Title
              level={5}
              className="!mb-3 !mt-0 shrink-0 text-neutral-500 !text-2xl"
            >
              Users
            </Title>
            <div className="min-h-0 flex-1 overflow-y-auto px-2 pb-2 [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-button]:hidden [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-neutral-300 hover:[&::-webkit-scrollbar-thumb]:bg-neutral-400">
              {users?.length ? (
                <Row gutter={[16, 16]}>
                  {users.map((item, index) => (
                    <Col key={index} xs={24} sm={12} md={8} lg={4}>
                      <UserCard item={item} />
                    </Col>
                  ))}
                </Row>
              ) : (
                <Empty description="No user data available" />
              )}
            </div>
          </div>

          <Divider className="shrink-0" />

          <div className="flex h-[min(280px,32vh)] min-h-[192px] shrink-0 flex-col px-2 pb-2 pt-1">
            <OverviewThisWeekTasks />
          </div>
        </div>
      )}
    </Page>
  );
};

export { Overview };
